export default __webpack_public_path__ + "static/media/release3.85c69db1.jpeg";